// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-j_gA","advertDetailContactGroup__header":"c-j_gB","advertDetailContactGroup__value":"c-j_gC"};